/* 预测建议选择独立计数；不采集搜索词，不阻挡导航，不重复发送标准搜索事件。 */
(function (factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else factory(window, document);
})(function installSearchAnalytics(win, doc) {
  'use strict';
  if (win.__roomdenSearchAnalyticsInstalled || win.Shopify?.designMode) return;
  win.__roomdenSearchAnalyticsInstalled = true;
  const target = 'G-DFBCGLVJN2';
  const key = 'roomden:search-selection:v1';
  const types = new Set(['product', 'query', 'collection', 'article', 'page']);
  const documentId = String(Math.random()); // 仅本地防止在即将离开的文档发送，不传给Google。
  let timer, attempts = 0, memory = null;
  function allowed() {
    try { return win.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function clear() { memory = null; try { win.sessionStorage.removeItem(key); } catch (_) {} }
  function configured() {
    return typeof win.gtag === 'function' && Array.isArray(win.dataLayer) &&
      win.dataLayer.some(x => x?.[0] === 'config' && x[1] === target) &&
      win.dataLayer.some(x => x?.[0] === 'event' && x[1] === 'page_view' &&
        (x[2]?.send_to === target || (Array.isArray(x[2]?.send_to) && x[2].send_to.includes(target))));
  }
  function flush() {
    timer = null;
    if (!allowed()) { clear(); return; }
    try {
      const value = memory || JSON.parse(win.sessionStorage.getItem(key) || 'null');
      if (!value) return;
      if (!types.has(value.type) || !Number.isFinite(value.created) ||
          Date.now() - value.created < 0 || Date.now() - value.created > 60000) { clear(); return; }
      if (!memory && (value.sourceDocument === documentId || value.destination !== win.location.pathname)) return;
      if (!configured()) {
        if (++attempts < 60) timer = win.setTimeout(flush, 1000);
        return;
      }
      // 先清理待发送记录，刷新不会再次入队。入队不等于服务器收到。
      clear();
      win.gtag('event', 'roomden_search_select', {
        send_to: target, suggestion_type: value.type, transport_type: 'beacon',
        page_location: win.location.origin + win.location.pathname,
        page_referrer: ''
      });
    } catch (_) { clear(); }
  }
  function start() { if (timer) win.clearTimeout(timer); attempts = 0; flush(); }
  doc.addEventListener('click', event => {
    const link = event.target?.closest?.('predictive-search [data-predictive-search] a[href]');
    if (!link || event.defaultPrevented || event.button > 0 || event.detail > 1 || !allowed()) return;
    try {
      const url = new URL(link.href, win.location.origin);
      if (url.origin !== win.location.origin) return;
      const type = /\/products\/[^/]+\/?$/.test(url.pathname) ? 'product' :
        /\/collections\/[^/]+\/?$/.test(url.pathname) ? 'collection' :
        /\/blogs\/[^/]+\/[^/]+\/?$/.test(url.pathname) ? 'article' :
        /\/pages\/[^/]+\/?$/.test(url.pathname) ? 'page' :
        /\/search\/?$/.test(url.pathname) && url.searchParams.get('q')?.trim() ? 'query' : null;
      if (!type) return;
      if (timer) win.clearTimeout(timer);
      clear();
      const value = {type, created: Date.now()};
      if (event.metaKey || event.ctrlKey || event.shiftKey || link.target === '_blank') {
        // 新标签页复制sessionStorage；留在当前页的选择只存内存，避免两边重复发送。
        memory = value;
        start();
      } else {
        // 普通导航在目标文档发送；当前文档不入队，避免卸载时丢失。
        win.sessionStorage.setItem(key, JSON.stringify({...value, sourceDocument: documentId, destination: url.pathname}));
      }
    } catch (_) { /* 存储不可用时不影响正常导航。 */ }
  });
  doc.addEventListener('visitorConsentCollected', start);
  function ready() {
    if (typeof win.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') start();
    else if (typeof win.Shopify?.loadFeatures === 'function') {
      try { win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) start(); }); }
      catch (_) { clear(); }
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
});
